import { UploadContext } from 'global/cnr/contexts/UploadContext';
import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess';
import { DataModificationsContext } from 'global/pageItem/modification/UiDataModifications';
import { dataModificationTypes } from 'global/viewSettings/enums/itemActionTypes';
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { Icon, Image } from 'semantic-ui-react';
import { ManifestContext } from '../../cnr/contexts/ManifestContext';
import { ParentContext } from '../../cnr/contexts/ParentContext';
import { gEnums } from '../../enums/globalEnums';
import { openExternal } from '../../viewSettings/helpers/settingsLinks';
import Wrapper, { wrapperTypes } from '../../wrappers/Wrapper';
import UiSaveButtons from '../buttons/UiSaveButtons';
import { createManifestIcons } from '../imaging/createManifestIcons';
import ImageList from './ImageList';

const ImageDropzone = (props) => {

  const { forFileManagement, forMulti, noImageDisplay, callback_imageFiles } = props

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { paps_state } = states
  const { pathViews } = paps_state

  const appUserAccess = useAppUserAccess()
  const { isSuperAdmin } = appUserAccess ?? {}

  const dataModificationContext = useContext(DataModificationsContext)
  const { dataModifications_state } = dataModificationContext ?? {}
  const { dataModification, dataModificationType } = dataModifications_state ?? {}

  const uploadContext = useContext(UploadContext)
  const { upload_state, upload_handlers } = uploadContext ?? {}
  const { appImage, storageType, manifestFiles } = upload_state ?? {}

  const manifestContext = useContext(ManifestContext);
  const { manifest_state } = manifestContext ?? {}
  const { manifestIcons } = manifest_state ?? {}
  const { manifest_4 } = manifestIcons ?? {}

  const [imageDropedFile, setImageDroppedFile] = useState(null);
  const [imageDroppedFiles, setImageDroppedFiles] = useState([]);

  const [imageDroppedPreview, setImageDroppedPreview] = useState(null);
  const [imageDroppedPreviews, setImageDroppedPreviews] = useState([]);
  const [manfestDroppedPreviews, setManifestDroppedPreviews] = useState([])

  const allowUpdate = forFileManagement || (storageType === gEnums.storageTypes.manifest) ? true : false

  const captions = useMemo(() => {
    // console.group('ImageDropzone')
    // console.log('appImage', appImage)
    // console.groupEnd()
    switch (dataModificationType) {
      case dataModificationTypes.images:
        return {
          icon: 'image',
        }

      case dataModificationTypes.pdfs:
        return {
          icon: 'file pdf outline',
        }

      default:
        return {
          icon: 'image',
        }
    }
  })

  useEffect(() => {
    if (forMulti) {
      if (imageDroppedFiles) {
        upload_handlers && upload_handlers.handleAmmend_allFiles(imageDroppedFiles, storageType)
        let previews = []
        _.forEach(imageDroppedFiles, (image_file) => {
          const preview = URL.createObjectURL(image_file.fileImage);
          previews.push(preview)
        })
        setImageDroppedPreviews(previews);
      }
    } else {
      upload_handlers && upload_handlers.handleAmmend_allFiles(imageDropedFile ? [imageDropedFile] : [], storageType)
      if (imageDropedFile) {
        const preview = URL.createObjectURL(imageDropedFile.fileImage);
        switch (storageType) {
          case gEnums.storageTypes.manifest:
            const manifestName = 'manifest'
            createManifestIcons(imageDropedFile.fileImage).then(res => {
              const _manifestFiles = []
              res.forEach((r, index) => {
                const _fileImage = new File([r], manifestName + '_' + index, { type: r.type })
                _manifestFiles.push({ name: _fileImage.name, fileImage: _fileImage })
              })
              setManifestDroppedPreviews(_manifestFiles)
            })
          default:
          // nothing
        }
        setImageDroppedPreview(preview);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageDropedFile, imageDroppedFiles]);

  useEffect(() => {
    if (callback_imageFiles && imageDroppedPreviews) {
      callback_imageFiles(imageDroppedPreviews, imageDroppedFiles)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageDroppedPreviews]);

  const getManifestImage = () => {
    if (manifest_4 && manifest_4.fileUrl) {
      return <div style={{ padding: '1em' }}>
        <Image size='small' src={manifest_4.fileUrl} />
      </div>
    }
  }

  const uploadImageToFirebase = async () => {
    switch (storageType) {
      case gEnums.storageTypes.manifest:
        upload_handlers.handleUpload_manifest(manifestFiles, pathViews)
        break;
      default:
        upload_handlers.handleUpload_allFiles()
    }
  }

  const handleOpen_storage = () => openExternal.db(pathViews, true)

  const onDrop = useCallback((acceptedFiles) => {
    if (forMulti) {
      setImageDroppedFiles((prevFiles) => {
        const newFiles = acceptedFiles
          .map((fileImage) => ({ name: fileImage.name, fileImage }))
          .filter((newFile) => !prevFiles.some((prevFile) => prevFile.name === newFile.name));
        return [...prevFiles, ...newFiles];
      });
    } else {
      const fileImage = acceptedFiles[0];
      if (fileImage) {
        setImageDroppedFile({ name: fileImage.name, fileImage });
      } else {
        setImageDroppedFile();
      }
    }
    // Get the first accepted file
    const fileImage = acceptedFiles[0];
    if (fileImage) {
      setImageDroppedFile({ name: fileImage.name, fileImage });
    }
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      'image/*': [],
      'application/pdf': [],
    },
    multiple: forMulti,
  });

  const image_solo = (src) => <Image size='small' src={src} alt={'imageEdit'}></Image>

  const image_file = (f) => {
    switch (dataModificationType) {
      case dataModificationTypes.pdfs:
        return <Icon name={'file pdf outline'} size='huge' color={'blue'} />
      default:
        const src = URL.createObjectURL(f?.fileImage)
        return <Image size='small' src={src} alt={'imageEdit'} ></Image>
    }
  }

  const div_images = () => <ImageList listItems={imageDroppedPreviews} storageType={storageType} />

  const div_manifestImages = () => <Wrapper
    header={<div className={'header-flex'}>
      <div>Manifest Images</div>
      {isSuperAdmin && <div><Icon name={'external alternate'} color='orange' onClick={(e) => { handleOpen_storage(e) }} /></div>}
    </div>}
    content={<ImageList listItems={manfestDroppedPreviews} noSize={true} />}
    wrapperType={wrapperTypes.padded}
    noMid={true}
  />

  const imageDrop = () => {
    const hasImage = imageDropedFile || !_.isEmpty(imageDroppedFiles) || !_.isEmpty(manfestDroppedPreviews)
    return <div
      {...getRootProps()}
      className='image-drop'
    >
      <input {...getInputProps()} />
      {!hasImage && (<Icon.Group size={!allowUpdate ? 'big' : null}>
        <Icon name={captions.icon} color='blue' />
        <Icon corner name='add' />
      </Icon.Group>)}
      {!noImageDisplay && imageDroppedPreview && image_file(imageDropedFile)}
      {!noImageDisplay && imageDroppedPreviews && !_.isEmpty(imageDroppedFiles) && div_images()}
      {!noImageDisplay && manfestDroppedPreviews && !_.isEmpty(manfestDroppedPreviews) > 0 && div_manifestImages()}
    </div>
  }

  const content_images = () => <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
    {appImage?.currentUrls?.full && image_solo(appImage.currentUrls.full)}
    {imageDrop()}
  </div>

  const wrapper = () => <Wrapper
    header={storageType === 'manifest' ? 'Manifest' : null}
    content={content_images()}
    search={getManifestImage()}
    footer={allowUpdate && <UiSaveButtons save={{ oc: uploadImageToFirebase, disabled: !imageDropedFile, caption: 'Upload Image File' }} />}
    wrapperType={wrapperTypes.padded}
    noMid={true}
    css={{ header: 'ip-url', container: 'manifest-wrapper' }}
  />

  return allowUpdate ? wrapper() : content_images();
};

export default ImageDropzone;
